(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["inovago-service-catalog"] && !Shopify.designMode) return;
  try {
    
function initInovagoCatalog(root) {
  root.querySelectorAll('[data-service-catalog]').forEach(catalog => {
    const tools = catalog.querySelector('[data-service-tools]');
    if (!tools || catalog.dataset.ready) return;
    catalog.dataset.ready = 'true';
    tools.hidden = false;
    const search = catalog.querySelector('[data-service-search]');
    const group = catalog.querySelector('[data-service-group]');
    const cards = Array.from(catalog.querySelectorAll('[data-service-card]'));
    const normalize = value => value.normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase();
    function filter() {
      const query = normalize(search.value.trim());
      let count = 0;
      cards.forEach(card => {
        const visible = (group.value === 'all' || card.dataset.group === group.value) && normalize(card.textContent).includes(query);
        card.hidden = !visible;
        if (visible) count++;
      });
      catalog.querySelector('[data-service-count]').textContent = count + ' ' + catalog.querySelector('[data-service-count-label]').textContent;
      catalog.querySelector('[data-service-none]').hidden = count !== 0;
    }
    search.addEventListener('input', filter);
    group.addEventListener('change', filter);
    filter();
  });
}
initInovagoCatalog(document);
document.addEventListener('shopify:section:load', event => initInovagoCatalog(event.target));

  } catch(e) { console.error(e); }
})();
})();
